import React, { useContext } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Skeleton, Stack } from '@mui/material';
import { useSiteVarsFunctions } from '../../hooks/use-site-vars-functions';
import PremPlayersContext from '../../contexts/premplayers-context';
import { LeaderboardContext } from '../../contexts/leaderboard-context';
import { PlayerImage } from '../player/player-image';

export const AcceptedOffersTable = ({ offers }) => {
  const { getPlayerPositionById, getTeamById } = useSiteVarsFunctions();
  const { premPlayersData, isLoadingPremPlayersData } = useContext(PremPlayersContext);
  const { leaderboardData } = useContext(LeaderboardContext);

  const getPlayerData = (playerId) => {
    return premPlayersData.find(player => player.playerId === playerId);
  };

  const getClubNameById = (clubId) => {
    const club = leaderboardData.find(team => team.clubId == clubId);
    return club ? club.clubName : clubId;
  };

  if (!offers || offers.length === 0) {
    return <Typography variant="h6" sx={{ mb: 2 }}>No accepted offers found for the current window.</Typography>;
  }

  if (isLoadingPremPlayersData) {
    return (
      <Box sx={{ width: '100%' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="accepted offers table">
            <TableHead>
              <TableRow>
                <TableCell>Player Name</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell>Clubs</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell colSpan={4}>
                  <Stack spacing={1}>
                    <Skeleton variant="rounded" width={"100%"} height={26} />
                    <Skeleton variant="rounded" width={"100%"} height={26} />
                    <Skeleton variant="rounded" width={"100%"} height={26} />
                  </Stack>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 410 }} aria-label="accepted offers table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingLeft: 2, paddingRight: 0 }}>Player</TableCell>
              <TableCell sx={{ padding: '6px 14px' }}></TableCell>
              <TableCell align="right">Amount</TableCell>
              <TableCell sx={{ paddingRight: 0 }}>Clubs</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {offers.map((offer) => {
              const player = getPlayerData(offer.playerId);
              if (!player) return null;

              return (
                <TableRow
                  key={offer.offerId}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell sx={{ paddingLeft: 2, paddingRight: 0, paddingBottom: 0 }}>
                    <PlayerImage player={player} />
                  </TableCell>
                  <TableCell sx={{ padding: '6px 14px', paddingLeft: 1 }}>
                    <span>{player.lastName}</span>
                    <br />
                    <span style={{ fontWeight: 'bold' }}>{getPlayerPositionById(player.positionId).name_short}</span> {getTeamById(player.teamId).name_short}
                  </TableCell>
                  <TableCell>{offer.amount}</TableCell>
                  <TableCell sx={{ paddingRight: 0 }}><b>From:</b> {getClubNameById(offer.from)}<br /><b>To:</b> {getClubNameById(offer.to)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};